import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { useAcademicsService } from '../../../../apis/academics/useAcademicsService';
import { IAcademicsScheduleResponse } from '../../../../apis/academics/academicsSchedules.interfaces';

type TQueryError = IFHError<{ message: string }>;
export const getAcademicsSchedulesKey = 'get-academics-schedules';

export type TAcademicsSchedulesParams = {
  page?: number;
  limit?: number;
  academicYear?: string;
  grade?: string;
  classId?: string;
};

export const useAcademicsSchedulesHook = (
  params: TAcademicsSchedulesParams,
  options?: UseQueryOptions<IAcademicsScheduleResponse, TQueryError>
): UseQueryResult<IAcademicsScheduleResponse, TQueryError> => {
  const { getAcademicsSchedules } = useAcademicsService();

  return useQuery<IAcademicsScheduleResponse, TQueryError>({
    queryKey: [getAcademicsSchedulesKey, params],
    queryFn: () => getAcademicsSchedules(params),
    enabled: true,
    ...options,
  });
};
